import { IEltCustomerRevenue } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCustomerRevenue'
import { CUSTOMER_REVENUE_TOTAL } from 'legacy/lut/components/widgets/public/partner360/ELT/configs'
import { getFieldByActualsValueType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFieldByActualsValueType'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import {
  getCurrentYearThView,
  getPrevYearThView,
} from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/helpers/getDynamicThView'
import { ShortRevenueName } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/revenueCommon/shortRevenueName/ShortRevenueName'
import { ShortYearRevenue } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/revenueCommon/shortYearRevenue/ShortYearRevenue'
import { ShortYoYRevenue } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/revenueCommon/shortYoYRevenue/ShortYoYRevenue'
import { IColumn } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/types'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

interface IProps {
  onChange: (field: string, keyValue: string) => (value: string | number) => void
  currentYear: number
  currentQuarter: number
  netNdpValue: ActualsValueTypes
  onlyCurrentAndPrevYear?: boolean
}

export const getCustomerRevenueColumns = ({
  currentYear,
  currentQuarter,
  netNdpValue,
  onChange,
}: IProps): IColumn<IEltCustomerRevenue>[] => {
  const prevYearTotalField = getFieldByActualsValueType('PrevYearTotal', netNdpValue)
  const curYearTotalField = getFieldByActualsValueType('CurYearTotal', netNdpValue)
  const yoyField = getFieldByActualsValueType('YoY', netNdpValue)

  return [
    {
      title: getFormedEltTranslation('customer-revenue-table-revenue'),
      field: 'TranslationKey',
      renderComponent: ({ value, keyValue }) => (
        <ShortRevenueName value={value || ''} keyValue={keyValue} />
      ),
    },
    {
      field: prevYearTotalField,
      titleRenderFn: () => getPrevYearThView(currentYear, 'customer'),
      renderComponent: ({ value, keyValue }) => (
        <ShortYearRevenue
          value={value || ''}
          keyValue={keyValue}
          field={prevYearTotalField}
          onChange={onChange}
          isEditable={keyValue !== CUSTOMER_REVENUE_TOTAL}
        />
      ),
    },
    {
      field: curYearTotalField,
      titleRenderFn: () => getCurrentYearThView(currentYear, currentQuarter, 'customer'),
      renderComponent: ({ value, keyValue }) => (
        <ShortYearRevenue
          value={value || ''}
          keyValue={keyValue}
          field={curYearTotalField}
          onChange={onChange}
          isEditable={keyValue !== CUSTOMER_REVENUE_TOTAL}
        />
      ),
    },
    {
      title: getFormedEltTranslation('customer-revenue-table-yoy-short'),
      field: yoyField,
      renderComponent: ({ value, keyValue }) => {
        return <ShortYoYRevenue value={value} keyValue={keyValue} />
      },
    },
  ]
}
